var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.6 47.4H47.4v105.2h105.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M152.6 200l47.4-47.4h-47.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M200 47.4h-47.4v105.2H200z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M152.6 152.6H47.4V200h105.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M0 152.6v33.1C0 193.6 6.4 200 14.3 200h33.1v-47.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M200 47.4V14.3C200 6.4 193.6 0 185.7 0h-33.1v47.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M152.6 0H14.3C6.4 0 0 6.4 0 14.3v138.3h47.4V47.4h105.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M68.2 129.3c-3.9-2.6-6.6-6.5-8.1-11.6l9.1-3.8c.8 3.2 2.3 5.6 4.3 7.3 2 1.7 4.5 2.6 7.4 2.6 3 0 5.5-.9 7.6-2.7 2.1-1.8 3.2-4.1 3.2-6.9 0-2.8-1.1-5.2-3.4-7-2.2-1.8-5.1-2.7-8.4-2.7h-5.3v-9h4.7c2.9 0 5.3-.8 7.3-2.4 2-1.6 3-3.7 3-6.4 0-2.4-.9-4.4-2.7-5.8-1.8-1.5-4-2.2-6.7-2.2-2.7 0-4.8.7-6.3 2.1-1.6 1.4-2.7 3.2-3.4 5.2l-9-3.8c1.2-3.3 3.3-6.3 6.5-8.8 3.2-2.6 7.2-3.8 12.2-3.8 3.6 0 6.9.7 9.8 2.1 2.9 1.4 5.2 3.4 6.8 5.9 1.7 2.5 2.5 5.3 2.5 8.4 0 3.2-.8 5.8-2.3 8-1.5 2.2-3.4 3.9-5.6 5v.5c2.9 1.2 5.3 3.1 7.2 5.6 1.9 2.5 2.8 5.5 2.8 9.1 0 3.5-.9 6.7-2.7 9.4-1.8 2.8-4.3 4.9-7.4 6.5-3.2 1.6-6.7 2.4-10.6 2.4-4.5 0-8.7-1.3-12.5-3.9zM122.7 85.3l-10 7.2-5-7.6 18-13h6.9v61.3h-9.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.1d976c2529220da9caabaf9c6804ae2d.svg";
export { ForwardRef as ReactComponent };